import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Card,
  Link,
  Divider,
} from "@mui/material";
import { Helmet } from "react-helmet-async";

import HaveQuestions from "../components/HaveQuestions";

import aboutBg from "../assets/about-bg.png";
import diffBg from "../assets/Differentiation-bg.png";
import immrsExpBg from "../assets/Immersive-Experience-bg.png";
import servicesBg from "../assets/DAM-Service.png";
import productAgBg from "../assets/productAgnosticBg.png";
import DAMTrainingCourseBg from "../assets/DAMTrainingCourse-bg.png";
import discoveryBg from "../assets/damDiscovery.png";
import practiceBg from "../assets/practicePage.png";
import DAMJourneyBg from "../assets/DAMJourneyBg-PS.png";
import filterImage from "../assets/FilterVintageOutlined.png";
import msgIllustration from "../assets/No Message illustration.png";
import vector from "../assets/Vector.png";

const randomPages = [
  { linkLabel: "About",
    text: "Helping organizations streamline, organize, and maximize the value of their digital assets through expert guidance and innovative solutions.", 
    image: aboutBg,
    url: "/about",
  },
  { linkLabel: "Differentiation",
    text: "We don’t just implement DAM—we transform how your organization works with digital assets through strategy, execution, and continuous optimization.", 
    image: diffBg,
    url: "/differentiation",
  },
  { linkLabel: "Immersive Experience",
    text: "We opt in for an immersive experience. This means that we work the details with practitioners in your organization in a real-life and real-time learning journey. We accomplish this by executing our proprietary DAM playbook with you and your team members as active contributors. This also means no webinars and certainly no certification classes.", 
    image: immrsExpBg,
    url: "/immersive-experience",
  },
  { linkLabel: "Services",
    text: "From strategy to implementation and beyond — we help you design, deploy, and optimize Digital Asset Management solutions that scale with your business.", 
    image: servicesBg,
    url: "/services",
  },
  { linkLabel: "Product Agnostic",
    text: "We don’t sell tools—we design the right DAM ecosystem tailored to your business goals.", 
    image: productAgBg,
    url: "/product-agnostic",
  },
  { linkLabel: "DAM Training",
    text: "Master the principles of Digital Asset Management through a structured, product-agnostic training program designed for real-world implementation.", 
    image: DAMTrainingCourseBg,
    url: "/dam-trainiong-corporate",
  },
  { linkLabel: "Discovery Framework",
    text: "A structured methodology designed to capture your current DAM processes, challenges, and requirements—laying the foundation for the right solution.", 
    image: discoveryBg,
    url: "/discovery-framework",
  },
  { linkLabel: "Our Practice",
    text: "Inspired by the tradition of professional practices in medicine and law, our firm is built on the principles of “The Practice.” We apply this same level of vocational dedication and specialized expertise to your digital assets.", 
    image: practiceBg,
    url: "/our-practice",
  },
  { linkLabel: "DAM Journey",
    text: "We walk with you through your Asset Lifecycle Management journey", 
    image: DAMJourneyBg,
    url: "/dam-journey",
  },
];

const Congrats = () => {

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [{ linkLabel, text, image, url }] = useState(
    () => randomPages[Math.floor(Math.random() * randomPages.length)]
  );  

  return (
    <Box sx={{ backgroundColor: "#F9F9F9" }}>
      <Helmet>
        <title>DAM Journey - Congrats</title>
        <meta
          name="description"
          content="Helping your organization to discover, plan, implement, and operate Digital Asset Management solutions to unlock the full value of your assets."
        />
        <meta
          property="keywords"
          content="DAM, DAM Journey, DAM Practice, DAM Consultant, DAM Consulting, DAM Practitioner, DAM Service, DAM Product, DAM Discovery, DAM Implementation, DAM Deployment, Contact"
        />
      </Helmet>

      {/* Congrats Section */}
      <Box
        sx={{
          py: "48px",
          px: "84px",
          "@media (max-width: 1200px)": {
            px: "24px",
          },
          "@media (max-width: 780px)": {
            px: "16px",
          },
        }}
      >
        <Box
          sx={{
            backgroundColor: "#F5F5F5",
            borderRadius: "16px",
            overflow: "hidden",
            display: "flex",
            minHeight: "640px",
            "@media (max-width: 1200px)": {
              flexDirection: "column",
            },
          }}
        >
          {/* LEFT PANEL */}
          <Box
            sx={{
              width: "50%",
              background: "linear-gradient(97.94deg, rgba(255, 193, 215, 0.3) 5.07%, #DBDAFD 94.73%)",
              px: "32px",
              pt: "32px",
              pb: "70px",
              gap: "24px",
              display:"flex",
              flexDirection:"column",
              "@media (max-width: 1200px)": {
                width: "100%",
              },
              "@media (max-width: 780px)": {
                px: "16px",
              },
            }}
          >
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: "regular",
                lineHeight: 1.8,
                color: "#666666",
              }}
            >
              Helping your organization to discover, plan,
              implement, and operate Digital Asset Management
              solutions to unlock the full value of your assets.
            </Typography>

            <Box
              sx={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",                
                py: "20px",
                gap: "10px",                
              }}
            >
              <Divider 
                sx={{ 
                  width: "100%",
                  "@media (max-width: 1200px)": {
                    borderWidth: "1px",
                  },
                }} 
              />

              <Box
                component="img"
                src={filterImage}
                alt=""
                sx={{
                  position: "absolute",
                  width: 45,
                  height: 45,
                  backgroundColor: "transparent",
                }}
              />
            </Box>
            
            <Box
              component="img"
              src={image}
              alt="DAM Journey Services"
              sx={{                
                width: "532px",
                display: "block",
                mx: "auto",
                gap: "10px",
                "@media (max-width: 1200px)": {
                  width: "656px",
                },
                "@media (max-width: 780px)": {
                  width: "296px",
                },
              }}
            />
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "baseline",
                color: "#666666",
                fontSize: "18px",
                lineHeight: "150%",

                "@media (max-width: 780px)": {
                  flexDirection: "column",
                  alignItems: "flex-start",
                },
              }}
            >
              <Link
                href={url}
                sx={{
                  color: "#1E0E62",
                  fontWeight: 700,
                  textDecoration: "underline",
                  mb: {
                    xs: "4px",
                    sm: 0,
                  },
                }}
              >
                {linkLabel}:&nbsp;
              </Link>

              <Typography
                component="span"
                sx={{
                  flex: 1,
                  minWidth: 0,
                  fontSize: "inherit",
                  lineHeight: "inherit",
                }}
              >
                {text}
              </Typography>
            </Box>
          </Box>

          {/* Right Panel */}
          <Box
            sx={{
              width: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              bgcolor: "#FFFFFF",
              "@media (max-width: 1200px)": {
                width: "100%",
                py: "32px",
              },
              "@media (max-width: 780px)": {
                width: "100%",
                py: "32px",
                px: "16px",
              },
            }}
          >
            <Box
              sx={{
                width: "500px",
                height: "409.4px",
                p: "3px",
                borderRadius: "32px",
                background:
                  "linear-gradient(141.98deg, #FF7FAC 29.08%, #5834BA 74.43%)",
              }}
            >
              <Card
                elevation={0}
                sx={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "30px",
                  backgroundColor: "#fff",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  px: 4,
                  textAlign: "center",
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: "187.25px",
                    height: "153.4px",
                    mb: 2,
                  }}
                >
                  {/* Vector */}
                  <Box
                    component="img"
                    src={vector}
                    alt=""
                    sx={{
                      position: "absolute",
                      top: "-5px",
                      left: "-125px",
                      width: "22px",
                      height: "22px",
                      zIndex: 2,
                      "@media (max-width: 780px)": {
                        top: "10px",
                        left: "-40px",                        
                      },
                    }}
                  />

                  <Box
                    component="img"
                    src={msgIllustration}
                    alt=""
                    sx={{
                      width: "187.25px",
                      height: "153.4px",
                    }}
                  />
                </Box>
                <Typography
                  sx={{
                    fontWeight: "semiBold",
                    fontSize: "2rem",
                    color: "#2A2177",
                    mb: 1,
                  }}
                >
                  Congrats!
                </Typography>

                <Typography
                  sx={{
                    fontSize: "1rem",
                    fontWeight: "regular",
                    color: "#666666",
                    maxWidth: "436px",
                    lineHeight: "175%",
                    mb: 1,
                  }}
                >
                  Thank you for contacting us. One of our 
                  account managers will reach out to you 
                  promptly.
                </Typography>
                <Divider 
                  sx={{ 
                    width: "50%",
                    mb: 1,
                  }}
                />
                <Button
                  variant="contained"
                  onClick={() => navigate("/contact")}
                  sx={{
                    width : "101px",
                    height: "42px",
                    gap: "8px",
                    py: "8px",
                    px: "32px",                  
                    borderRadius: "999px",
                    backgroundColor: "#C22A43",
                    textTransform: "none",
                  }}
                >
                  Done
                </Button>
              </Card>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Congrats;
